import React from 'react'
import styled from 'styled-components'

const StyledInputWrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${({theme}) => theme.darkMode ? '#2D241F' : '#FFF9F0'};
  border-radius: 10px;
  height: 72px;
  padding: 0 16px;
  margin: 16px 0 48px;
`
const StyledInput = styled.input`
  flex: 1;
  width: 0;
  background: none;
  border: 0;
  color: ${({theme}) => theme.bsText4};
  font-size: 18px;
  height: 56px;
  margin: 0;
  padding: 0;
  outline: none;
`

export interface InputProps {
  endAdornment?: React.ReactNode,
  onChange: (e: React.FormEvent<HTMLInputElement>) => void,
  placeholder?: string,
  startAdornment?: React.ReactNode,
  value: string,
}

const Input: React.FC<InputProps> = ({
  endAdornment,
  onChange,
  placeholder,
  startAdornment,
  value,
}) => {
  return (
    <StyledInputWrapper>
      {!!startAdornment && startAdornment}
      <StyledInput placeholder={placeholder} value={value} onChange={onChange} />
      {!!endAdornment && endAdornment}
    </StyledInputWrapper>
  )
}

export default Input